'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveParams$() {
  this.c5G = null;
  this.c5H = false;
  this.c5E = null;
  this.c5F = false;
}
export { $c_Lpresto_types$DirectiveParams$ as $c_Lpresto_types$DirectiveParams$ };
$p = $c_Lpresto_types$DirectiveParams$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveParams$;
/** @constructor */
function $h_Lpresto_types$DirectiveParams$() {
}
export { $h_Lpresto_types$DirectiveParams$ as $h_Lpresto_types$DirectiveParams$ };
$h_Lpresto_types$DirectiveParams$.prototype = $p;
$p.cI5 = (function() {
  if ((!this.c5H)) {
    this.c5G = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c5H = true;
  }
  return this.c5G;
});
$p.v4 = (function() {
  if ((!this.c5F)) {
    this.c5E = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c5F = true;
  }
  return this.c5E;
});
var $d_Lpresto_types$DirectiveParams$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveParams$, "presto.types$DirectiveParams$", ({
  ZB: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveParams$ as $d_Lpresto_types$DirectiveParams$ };
var $n_Lpresto_types$DirectiveParams$;
function $m_Lpresto_types$DirectiveParams$() {
  if ((!$n_Lpresto_types$DirectiveParams$)) {
    $n_Lpresto_types$DirectiveParams$ = new $c_Lpresto_types$DirectiveParams$();
  }
  return $n_Lpresto_types$DirectiveParams$;
}
export { $m_Lpresto_types$DirectiveParams$ as $m_Lpresto_types$DirectiveParams$ };
//# sourceMappingURL=presto.types$-Directive-Params$.js.map
